import { all, takeLatest } from 'redux-saga/effects';
import {
  GET_COMPANY_INVOICES,
  GET_COMPANY_MAPPED_OFFICES,
  GET_COMPANY_PROFILE,
  GET_CONSUMPTION_DETAILS,
  GET_EVENT_DETAILS,
  GET_HOME_PAGE,
  GET_INVOICE_DETAILS,
  GET_PAYMENTS_FOR_INVOICE,
  GET_PREVIOUS_TOPUPS,
  GET_UPCOMING_TOPUPS,
  VERIFY_COMPANY,
} from '../../actions/company';
import {
  getCompanyDetailsSaga,
  getCompanyInvoicesSaga,
  getCompanyMappedOfficesSaga,
  getCompanyVerificationSaga,
  getConsumptionDetailsSaga,
  getEventDetailsSaga,
  getHomePageSaga,
  getInvoiceDetailsSaga,
  getPaymentsForInvoiceSaga,
  getPreviousTopupsSaga,
  getUpcomingTopupsSaga,
} from './getCompanyVerificationSaga';

function* companySagas() {
  yield all([
    yield takeLatest(GET_COMPANY_PROFILE.INITIATE, getCompanyDetailsSaga),
    yield takeLatest(VERIFY_COMPANY.INITIATE, getCompanyVerificationSaga),
    yield takeLatest(GET_HOME_PAGE.INITIATE, getHomePageSaga),
    yield takeLatest(GET_UPCOMING_TOPUPS.INITIATE, getUpcomingTopupsSaga),
    yield takeLatest(GET_PREVIOUS_TOPUPS.INITIATE, getPreviousTopupsSaga),
    yield takeLatest(GET_EVENT_DETAILS.INITIATE, getEventDetailsSaga),
    yield takeLatest(
      GET_CONSUMPTION_DETAILS.INITIATE,
      getConsumptionDetailsSaga,
    ),
    yield takeLatest(GET_COMPANY_INVOICES.INITIATE, getCompanyInvoicesSaga),
    yield takeLatest(GET_INVOICE_DETAILS.INITIATE, getInvoiceDetailsSaga),
    yield takeLatest(
      GET_COMPANY_MAPPED_OFFICES.INITIATE,
      getCompanyMappedOfficesSaga,
    ),
    yield takeLatest(
      GET_PAYMENTS_FOR_INVOICE.INITIATE,
      getPaymentsForInvoiceSaga,
    ),
  ]);
}

export default companySagas;
